import React/*, {Component}*/ from 'react';
//import PropTypes from 'prop-types';
//import {Redirect} from 'react-router';
import {Link} from 'react-router-dom';

export default class Tab extends React.Component {
	//constructor(props){
	//	super(props);
	//}
	render(){
		return (
            (this.props.link) ? <Link to={{ pathname: this.props.link, search: this.props.linkParams }}>{this.props.label}</Link> : <span>{this.props.label}</span>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/Tab.js